import { DesignModeProviderInterface } from "./DesignModeProviderInterface";

export class FromShopifyObjectDesignModeProvider
    implements DesignModeProviderInterface
{
    isDesignMode() {
        return window.Shopify?.designMode || null;
    }
}
